import React, { useState, Context, useEffect, useContext, useLayoutEffect } from 'react'
import { Employee } from 'models'
import axios from 'axios'
import Notification from 'antd/es/notification'
import { LoginAttempt } from 'components/login'
import debounce from 'lodash/debounce'

export type State = {
  currentUser: Employee | undefined
  currentUserIsAdmin: boolean
  loading: boolean
  windowWidth: number

  login: (crendentials: LoginAttempt) => Promise<any>
  logOut: () => void
}

const shadowContext = React.createContext<State | undefined>(undefined)

export const context = shadowContext as Context<State>

export const useCurrentUser = () => useContext(context)

function useWindowWidth(delay = 700) {
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    const debouncedHandleResize = debounce(handleResize, delay)
    window.addEventListener('resize', debouncedHandleResize)
    return () => {
      window.removeEventListener('resize', debouncedHandleResize)
    }
  }, [delay])

  return width
}

export const CurrentUserProvider = ({ children }: { children?: React.ReactNode }) => {
  const [currentUser, setCurrentUser] = useState<Employee | undefined>(undefined)

  const [loading, setLoading] = useState<boolean>(true)

  const resumeLogin = async () => {
    try {
      const { data } = (await axios.post(global.Config.backendUri + '/resume-login', {}, { timeout: 2000 })) as any
      setCurrentUser(data.user)
    } catch (e) {
      setCurrentUser(undefined)
    }

    setLoading(false)
  }

  useEffect(() => {
    resumeLogin()
  }, [])

  const logOut = () => {
    localStorage.removeItem('token')
    setCurrentUser(undefined)
  }

  const width = useWindowWidth(100)

  const login = async (credentials: LoginAttempt) => {
    try {
      const { data } = (await axios.post(global.Config.backendUri + '/login', { ...credentials })) as any
      setCurrentUser(data.user)
      localStorage.setItem('token', data.token)
    } catch (e) {
      if (JSON.stringify(e).includes('401')) {
        Notification.error({ message: 'Käyttäjällä ei ole oikeuksia', placement: 'bottomLeft' })
      } else {
        console.log(e)
        Notification.error({ message: JSON.stringify(e), placement: 'bottomLeft' })
      }
      setCurrentUser(undefined)
    }
  }

  const { Provider } = context

  return (
    <Provider
      value={{
        windowWidth: width,
        currentUser,
        currentUserIsAdmin: currentUser?.roles.includes('Admin') ? true : false,
        loading,
        login,
        logOut
      }}
    >
      {children}
    </Provider>
  )
}
